import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEmail = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M39.514 10.03c1.138 0 2.15.52 2.786 1.326L23.822 26.142 5.509 11.624c.612-.956 1.717-1.595 2.977-1.595zM5 34.643V14.248l13.14 10.417L5.027 35.061A3 3 0 0 1 5 34.644m1.202 2.513c.612.507 1.41.814 2.284.814h31.028c.75 0 1.447-.227 2.016-.612L27.567 26.185l-2.511 2.01c-.71.567-1.745.57-2.458.005l-2.549-2.021zm23.263-12.492 13.44 10.755a3.2 3.2 0 0 0 .095-.776v-20.81z"
	})
});
export default SvgEmail;
